import { useCallback } from "react";
import eventStore from "../stores/eventStore";
import { getEventData } from "../services/eventService";

export function useEvent() {
  const { event, setEvent } = eventStore();

  const getEvent = useCallback(async () => {
    try {
      const data = await getEventData();

      setEvent(data.event);
      return data;
    } catch (error) {
      console.error(`Failed to load event:`, error);
      return [];
    }
  }, [setEvent]);

  return {
    event,
    setEvent,
    getEvent,
  };
}
